import { getSavings } from '../../../services/getSavings';
import { useRecoilValue } from 'recoil';
import React from 'react';
import numeral from 'numeral';
import * as AppState from '../../../AppState';

const SavingsHighlight = (props: {price: number, countyId: number, isRealtyApplied: boolean, savingsUrl: string, closeDate: Date}) => {
	return (
		( props.closeDate ?
			<SellSavingsHighlight price={props.price} countyId={props.countyId} isRealtyApplied={props.isRealtyApplied} savingsUrl={props.savingsUrl}
			/>
			:
			<BuySavingsHighlight price={props.price} countyId={props.countyId} isRealtyApplied={props.isRealtyApplied} savingsUrl={props.savingsUrl}
			/>
		)
	);
};

const SellSavingsHighlight = (props: {price: number, countyId: number, isRealtyApplied: boolean, savingsUrl: string}) => {
	const userOnMobile = useRecoilValue(AppState.gsIsMobile);

	const SavingsFigure = () => {
		const formattedSavings = numeral((props.price * .03)).format();
		return (
			(
				userOnMobile ?
					<>
						<h3 className="fs-4 px-2" style={{fontWeight: 'bold'}}>Save up to <a href={props.savingsUrl} style={{ color: '#EA701B'}}>${formattedSavings}</a> with 1% Listing Fees</h3>
					</>
					:
					<>
						<h3 className="fs-4 px-4">and save up to <span style={{fontWeight: 'bold', color: '#EA701B'}}>${formattedSavings}</span></h3>
						<h3 className="fs-6 px-4"><a href={props.savingsUrl} style={{textDecoration: 'underline', fontWeight: 400 }}>See details</a></h3>
					</>
			)
		);
	};

	return (
		( userOnMobile ?
			<div className="position-relative py-1">
				<h3 className="fs-4 px-4" ></h3>
				{SavingsFigure()}
			</div>
			:
			<div className="position-relative text-center shadow border-radius cc-bg--white-100 py-2" style={{color: '#0c2c48'}}>
				<h3 className="fs-4 px-4 pt-10" >Sell with 1% Listing Fees</h3>
				<h3 className="fs-1 px-4" style={{fontWeight: 'bold'}}>${numeral(props.price.toString()).format()}</h3>
				{SavingsFigure()}
			</div>
		)
	);
};

const BuySavingsHighlight = (props: {price: number, countyId: number, isRealtyApplied: boolean, savingsUrl: string}) => {
	const [savingsArray, setSavingsArray] = React.useState<any>();
	const userOnMobile = useRecoilValue(AppState.gsIsMobile);

	async function generateSavings() {
		const [savingsJSON]: any[] = await getSavings(props.price, props.isRealtyApplied, props.countyId);
		setSavingsArray(savingsJSON);
	}

	React.useEffect(() => {
		if (props.countyId) {
			generateSavings();
		}
	}, [props.price, props.isRealtyApplied, props.countyId]);

	const SavingsFigure = () => {
		if (savingsArray) {
			const formattedSavings = numeral(savingsArray.MortgageSavings).format();
			return (
				(
					userOnMobile ?
						<>
							<h3 className="fs-4 px-2" style={{fontWeight: 'bold'}}>Save up to <a href={props.savingsUrl} style={{ color: '#EA701B'}}>${formattedSavings}</a> with Zero Closing Costs</h3>
						</>
						:
						<>
							<h3 className="fs-4 px-4">and save up to <span style={{fontWeight: 'bold', color: '#EA701B'}}>${formattedSavings}</span></h3>
							<h3 className="fs-6 px-4"><a href={props.savingsUrl} style={{textDecoration: 'underline', fontWeight: 400 }}>See details</a></h3>
						</>
				)
			);
		}
	};

	return (
		( userOnMobile ?
			<div className="position-relative py-1">
				<h3 className="fs-4 px-4" ></h3>
				{SavingsFigure()}
			</div>
			:
			<div className="position-relative text-center shadow border-radius cc-bg--white-100 py-2" style={{color: '#0c2c48'}} >
				<h3 className="fs-4 px-4 pt-10" >Buy with Zero Closing Costs</h3>
				<h3 className="fs-1 px-4" style={{fontWeight: 'bold'}}>${numeral(props.price.toString()).format()}</h3>
				{SavingsFigure()}
			</div>
		)
	);
};

export default SavingsHighlight;
